import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';
import CardSlider from '../../common/cards/CardSlider';
import AddIcon from '@material-ui/icons/Add';
import RoundedChip from '../../common/RoundedChip';
import { TextField, IconButton } from '@mui/material';
import { useForm } from 'react-hook-form';

const ListInput = ({ comment, onBlur, name, onChange, value, label }) => {
  const [newValue, setNewValue] = useState('');
  const inputRef = useRef(null);

  const { handleSubmit } = useForm();

  function addNewValue() {
    if (newValue !== '') {
      onChange([...value, newValue]);
      setNewValue('');
    }
  }

  return (
    <>
      <form onSubmitCapture={handleSubmit(addNewValue)}>
        <TextField
          className={styles.input}
          name={name}
          id={name}
          label={label}
          onBlur={onBlur}
          InputProps={{
            endAdornment: (
              <IconButton type="submit">
                <AddIcon />
              </IconButton>
            ),
            disableUnderline: true
          }}
          value={newValue}
          inputRef={inputRef}
          onChange={(e) => setNewValue(e.target.value)}
        />
      </form>
      <div className={styles.list}>
        <CardSlider extraClass={styles.chipsSlider}>
          {value.length !== 0 ? (
            value.map((data) => (
              <RoundedChip
                key={data.toString()}
                name={data}
                onDelete={() => {
                  onChange(value.filter((chip) => chip !== data));
                }}
              />
            ))
          ) : (
            <div className={styles.empty}>{comment}</div>
          )}
        </CardSlider>
      </div>
    </>
  );
};

ListInput.propTypes = {
  name: PropTypes.string,
  comment: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  onBlur: PropTypes.func,
  label: PropTypes.string
};

export default ListInput;
